import type { TFunction } from "i18next";

import { SectionTabsToolbar } from "~/shared/section";
import { ASSET_TABS, type AssetTab } from "../lib/asset-filter-utils";

interface AssetsListToolbarProps {
    t: TFunction;
    tab: AssetTab;
    onTabChange: (tab: AssetTab) => void;
}

// No disabled tabs — Folders is implemented. Kept as a hook for future stubs.
const DISABLED_TABS: ReadonlySet<AssetTab> = new Set<AssetTab>();

export function AssetsListToolbar({ t, tab, onTabChange }: AssetsListToolbarProps) {
    return (
        <SectionTabsToolbar
            tabs={ASSET_TABS}
            activeTab={tab}
            onTabChange={onTabChange}
            ariaLabel={t("assets:tabs.ariaLabel")}
            getLabel={(tabValue) => t(`assets:tabs.${tabValue}`)}
            isDisabled={(tabValue) => DISABLED_TABS.has(tabValue)}
            getDisabledTitle={() => t("assets:tabs.comingSoon", { defaultValue: "Coming soon" })}
        />
    );
}
